export default __webpack_public_path__ + "static/media/tms-portabella-8000.df623e3a.webp";